import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import SupportDetailPage from './pages/SupportDetailPage';
import SupportListPage from './pages/SupportListPage';

/** Migration guide Bölüm 3.12 SupportController — always visible, no gate. */
export const supportModule: ModuleDefinition = {
  routes: [
    { path: 'support', element: <SupportListPage /> },
    { path: 'support/:ticketId', element: <SupportDetailPage /> },
  ],
  menuItems: [{ label: 'Destek', path: 'support', icon: <SupportAgentOutlinedIcon /> }],
};
